module.exports = __webpack_public_path__ + "static/media/Viego_0.cbc53ec5.png";